appSocial.component('leaderCopy', {
    templateUrl: 'widgets/leader-copy/components/leader-copy/LeaderCopyComponent.html',
    bindings: {
        trader: '<',
        action: '<',
        onSuccess: '&',
        onStart: '&',
        onFail: '&',
        onValidation: '&'
    },
    controller: [
        '$scope',
        'SocialUserService',
        'SocialLocaleService',
        'SocialFavoriteService',
        'SocialPortfolioService',
        'SocialUtils',
        'SocialConstants',
        'SocialTypes',
        'LeaderCopyService',
        '$timeout',
        '$filter',
        class LeaderCopyComponent {
            constructor(
                $scope,
                SocialUserService,
                SocialLocaleService,
                SocialFavoriteService,
                SocialPortfolioService,
                SocialUtils,
                SocialConstants,
                SocialTypes,
                LeaderCopyService,
                $timeout,
                $filter
            ) {

                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;

                /**
                 * @type {SocialFavoriteService}
                 */
                this.favoriteService = SocialFavoriteService;

                /**
                 * @type {SocialPortfolioService}
                 */
                this.portfolioService = SocialPortfolioService;

                /**
                 * @type {LeaderCopyService}
                 */
                this.leaderCopyService = LeaderCopyService;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                this.actions = SocialTypes.CopyAction;

                this.validationTypes = SocialTypes.ValidationTypes;

                this.$timeout = $timeout;

                this.currencyConvertPipe = $filter('currencyConvert');

                this.currencyPipe = $filter('cryptoCurrency');

                this.translation = SocialLocaleService.translation;

                this.user = this.userService.get();

                this.amountConfig = {
                    min: 250,
                    max: 1000,
                    digits: 0,
                    step: 50,
                    viewName: this.translation.addFunds,
                    strictValidation: false
                }

                this.amount = {
                    value: this.calcAmount()
                };

                // converted to USD user balance
                this.maxAmount = 0;

                this.depositAmount = 0;

                // copy open trades
                this.copyOpen = false;

                // initial stoploss value in percents
                this.stopLoss = 65;

                this.editStopLoss = false;

                this.stopLossRange = {
                    min: 10,
                    max: 90
                }

                this.stopLossLabelOffset = this.stopLoss;

                this.watchAmount = $scope.$watch(() => this.stopLoss, (newVal, oldVal) => {
                    this.stopLossLabelOffset = this.stopLoss;
                    this.stopLossAmount = this.amount.value / 100 * this.stopLoss;
                });

                // stoploss amount in usd
                this.stopLossAmount = this.amount.value / 100 * this.stopLoss;
                this.watchStopLossAmount = $scope.$watch(() => this.amount.value, () => {
                    this.stopLossAmount = this.amount.value / 100 * this.stopLoss;
                })

                this.watchActionStart = $scope.$on(this.actions.StartCopy, () => this.copy());
                this.watchActionStop = $scope.$on(this.actions.StopCopy, () => this.stopCopy());

                this.validationMessage = '';
            }


            $onInit() {
                this.maxAmount = this.currencyConvertPipe((this.user.balance - this.portfolioService.sumFollowBalance), this.user.currency, 'USD');
                this.amountConfig.max = this.maxAmount;

                if (this.action === this.actions.StopCopy) {
                    this.amount.value = this.currencyConvertPipe(this.trader.followDeposit, this.user.currency, 'USD');
                    this.amountConfig = _.merge(this.amountConfig, {
                        readonly: true,
                        buttons: false
                    })
                }
            }

            $onDestroy() {
                this.watchAmount && this.watchAmount();
                this.watchActionStart && this.watchActionStart();
                this.watchActionStop && this.watchActionStop();
                this.watchStopLossAmount && this.watchStopLossAmount();
            }

            onAmountChange() {
                this.depositAmount = this.amount.value;
                const usdAmount = this.currencyConvertPipe(this.user.balance, this.user.currency, 'USD');

                // validation is not applicable for stop copy
                if (this.action === this.actions.StopCopy) {
                    return;
                }

                // validate funds
                if (this.depositAmount > this.amountConfig.max) {
                    this.validationMessage = this.translation.noSufficientFunds;
                    this.onValidation({error: this.validationTypes.Balance});
                    return;
                }

                // validate amount
                if (this.depositAmount < this.amountConfig.min) {
                    this.validationMessage = `${this.translation.minAmount} ${this.currencyPipe(this.amountConfig.min, 'USD')}`;
                    this.onValidation({error: this.validationTypes.MinAmount});
                    return;
                }

                if (this.depositAmount > this.amountConfig.max) {
                    this.validationMessage = `${this.translation.maxAmount} ${this.currencyPipe(this.amountConfig.max, 'USD')}`;
                    this.onValidation({error: this.validationTypes.MaxAmount});
                    return;
                }


                // any other case - validation success
                this.validationMessage = '';
                this.onValidation();

            }

            copy() {
                this.onStart();

                const amount = Number(this.currencyConvertPipe(this.amount.value, 'USD', this.user.currency));

                return this.leaderCopyService.followByLeader(this.trader.id, amount, this.stopLoss, this.copyOpen)
                    .then(() => {
                        this.onSuccess({amount: this.amount.value});
                    })
                    .catch(err => {
                        this.onFail({error: err});
                    })
            }

            stopCopy() {
                this.onStart();

                return this.leaderCopyService.unfollowLeader(this.trader.followId)
                    .then(() => {
                        this.onSuccess();
                    })
                    .catch(err => {
                        this.onFail({error: err});
                    })
            }

            calcAmount() {
                function roundHundred(value) {
                    return Math.round(value / 100) * 100;
                }

                const usdAmount = this.currencyConvertPipe(this.user.balance, this.user.currency, 'USD');
                const amount = Math.max(1000, Math.round((0.25 * usdAmount) / 100) * 100);

                console.log({
                    balance: this.user.balance,
                    usdAmount,
                    amount,
                    rounded: roundHundred(amount)
                })
                return roundHundred(amount);
            }

            toggleEditStopLoss() {
                this.editStopLoss = !this.editStopLoss;
            }
        }]
})
